import type { UseQueryOptions } from '@tanstack/react-query'

export const PULSE_QUERY_OPTIONS = {
  gcTime: 1000 * 60 * 60 * 24, // 24 hours
  staleTime: 1000 * 60 * 60 * 24, // 24 hours
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  refetchOnMount: false,
} satisfies Partial<UseQueryOptions>
